// Global (header/footer) tab — edits the shared header/footer/nav content that
// every storefront page renders (Neon page_content, page_type='global', key
// '__global'). Footer columns + social, and the Explore dropdown promo image +
// nav links. Not keyed by URL — one row for the whole store.
import React from 'react';
import PageBlocksEditor from './PageBlocksEditor';
import { getActiveEnv } from '../../services/env';

const STORE_DOMAINS = {
  sb1: 'the-crab-place-sandbox-1.mybigcommerce.com',
  sb2: 'the-crab-place-sandbox-2.mybigcommerce.com',
  prod: 'www.crabplace.com',
};

// Regions a global block can target. Footer columns sit left-to-right in the
// footer; social is the icon row; the two explore-* regions are the Explore
// mega-dropdown.
const REGIONS = [
  { value: 'footer-cols', label: 'Footer column' },
  { value: 'footer-social', label: 'Footer social icons' },
  { value: 'explore-img', label: 'Explore dropdown image' },
  { value: 'explore-nav', label: 'Explore dropdown links' },
  { value: 'nav-section', label: 'Content-page sub-nav' },
];

export default function SiteContentGlobalTab() {
  const env = getActiveEnv();
  const viewUrl = 'https://' + STORE_DOMAINS[env] + '/faqs/';
  return (
    <div style={{ padding: '4px 2px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, fontWeight: 600, padding: '3px 8px', borderRadius: 4, background: '#eef2ff', color: '#3730a3' }}>Editing env: {env.toUpperCase()}</span>
        <span style={{ fontSize: 12, color: '#6b7280' }}>Header/footer/nav shared by every page. Set each block's <b>Region</b> to place it.</span>
      </div>
      <PageBlocksEditor pageType="global" pageKey="__global" env={env} viewUrl={viewUrl} regions={REGIONS} />
    </div>
  );
}
